import { useCallback, useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import CardProduct from "./CardProduct";
import { useProductListQueryPbf } from "../../../hooks/purchaseHook/useProductListQueryPbf";

const SpecialOfferProductSwiper = () => {
  const sliderRef = useRef(null);
  const navigationNextRef = useRef(null);
  const navigationPrevRef = useRef(null);

  const { data: dataList, isFetching: isLoading } = useProductListQueryPbf({
    search: "",
    offset: 1,
    limit: 10,
    label_ids: [],
    category_ids: [], // not currently used
    principal_ids: [],
    offer_type: "special_offer",
    order: "created_desc",
  });
  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  return (
    <div className="w-full overflow-hidden relative px-12">
      <div
        className="z-5 text-[#2C3E5D] bg-white rounded-full flex items-center justify-center p-1 border cursor-pointer hover:bg-gray-100 w-[28px] h-[28px] absolute left-0 top-0 bottom-0 my-auto"
        id="slideLeft"
        onClick={() =>
          (document.getElementById("containerScrollOffer").scrollLeft -= 220)
        }
      >
        <FaChevronLeft />
      </div>
      <div
        className="text-[#2C3E5D] z-5 bg-white rounded-full flex items-center justify-center p-1 border cursor-pointer hover:bg-gray-100 w-[28px] h-[28px] absolute right-0 top-0 bottom-0 my-auto"
        id="slideRight"
        onClick={() =>
          (document.getElementById("containerScrollOffer").scrollLeft += 220)
        }
      >
        <FaChevronRight />
      </div>

      <div
        className="w-full flex gap-2 overflow-x-auto hide-scroll scroll-smooth"
        id="containerScrollOffer"
      >
        {dataList && !isLoading && dataList.data ? (
          dataList.data.map((item, i) => (
            <div className="w-[180px] shrink-0">
              <CardProduct product={item} type={item.product_so_id ? 2 : 1} />
            </div>
          ))
        ) : isLoading ? (
          [...Array(8).keys()].map((item) => {
            return (
              <div className="w-[180px] shrink-0">
                <CardProduct isLoadingCard={true} />
              </div>
            );
          })
        ) : (
          <p>Tidak ada data</p>
        )}
      </div>
    </div>
  );
};

export default SpecialOfferProductSwiper;
